// src/pages/UsuariosPage.tsx
import React from 'react';
import UsuarioList from '../components/usuarios/UsuarioList';

export default function UsuariosPage() {
    return <UsuarioList />;
}
